import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/vinov/installments', config);
}

const get = async (id) => {
    return FinanceApi.get('/vinov/installments/' + id);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/vinov/installments/' + data.id, data);
    }
    return FinanceApi.post('/vinov/installments', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/vinov/installments/' + id, formData);
}

const del = async (code) => {
    return FinanceApi.delete('/vinov/installments/' + code);
}

export default {
    getAll,
    get,
    store,
    update,
    del
}
